export default "__VITE_ASSET__CHDuzevd__"